let language = {
    300620: "No matching pricing table",
};

export { language }